import { connect } from 'react-redux';

import PrivateStoreRedirect from './private-store-redirect'

const mapStateToProps = (state, ownProps ) => {
	const { profileData } = state.userData;
	const { personData } = profileData;

	return {
		personData,
	};
}


export default connect(
	mapStateToProps,
	null
)(PrivateStoreRedirect);